module.exports = __webpack_public_path__ + "static/media/EditGray.8db6939b.svg";